module.exports = __webpack_public_path__ + "j.no2.83dbfbd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/j.no2.jpg
// module id = sWs7
// module chunks = 0